import axios from "./axios";

// A Keeper invites a registered user to become the second Keeper. Nothing is granted until the
// invited user accepts; the server checks that the sender really is a Keeper of that page.
const assignKeeper = async (data: any) => {
  try {
    const endpoint = `/keeper/`;
    const response = await axios.post(endpoint, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error:", error.response.data);
      throw error.response;
    } else {
      console.error("Network error:", error);
      throw error;
    }
  }
};

const getInvitation = async (token: string) => {
  const response = await axios.get("/keeper/invitations/info", { params: { token } });
  return response.data as {
    status: "pending" | "accepted" | "canceled" | "expired";
    obituaryName: string;
    obituarySlug: string | null;
    inviterName: string | null;
    expiresAt: string;
  };
};

const acceptInvitation = async (token: string) => {
  const response = await axios.post("/keeper/invitations/accept", { token });
  return response.data as { message: string; obituarySlug: string | null };
};

// ----- Admin -----
export type AdminKeeperRow = {
  keeperId: number;
  person: string;
  email: string | null;
  type: "original" | "invited";
  status: "active" | "expired";
  invitedAt: string | null;
  invitedBy: string | null;
  acceptedAt: string | null;
  validUntil: string;
};
export type AdminInvitationRow = {
  invitationId: number;
  person: string;
  email: string;
  invitedBy: string | null;
  invitedAt: string;
  expiresAt: string;
};
export type AdminKeeperPage = {
  obituaryId: number;
  name: string;
  slugKey: string | null;
  maxKeepers: number;
  keepers: AdminKeeperRow[];
  pendingInvitations: AdminInvitationRow[];
};

const adminListPages = async (search = "", page = 1) => {
  const response = await axios.get("/keeper/admin/pages", { params: { search, page } });
  return response.data as { total: number; page: number; pages: AdminKeeperPage[] };
};
const adminAddKeeper = async (obituaryId: number, email: string) => {
  const response = await axios.post(`/keeper/admin/pages/${obituaryId}/keepers`, { email });
  return response.data;
};
const adminRemoveKeeper = async (keeperId: number) => {
  const response = await axios.delete(`/keeper/admin/keepers/${keeperId}`);
  return response.data;
};
const adminCancelInvitation = async (invitationId: number) => {
  const response = await axios.delete(`/keeper/admin/invitations/${invitationId}`);
  return response.data;
};

const keeperService = {
  assignKeeper,
  getInvitation,
  acceptInvitation,
  adminListPages,
  adminAddKeeper,
  adminRemoveKeeper,
  adminCancelInvitation,
};

export default keeperService;
